export const ERROR_FETCHING_ASSISTANT_REPORT="Error fetching assistant monthly report";
export const ERROR_FETCHING_DATA_MESSAGE="Error fetching data";
export const ERROR_FETCHING_USERS_FOR_ASSISTANT="Error fetching users for assistant";
export const ERROR_EXPORTING_DATA="Error exporting data into csv";
export const ERROR_EXPORTING_DATA_MESSAGE = "Failed to export data. Please try again.";
export const assistantheaders = ["Month", "Assistant Name", "Total Users", "Total Usage Count"]
export const tractusageheaders = ["Month", "User Name", "Email", "Prompt Count", "Total Token", "Cost"]
export const dailyusageheaders = ["Date", "User Name", "Email", "Prompt Count", "Total Token", "Cost"]
export const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ]